
<template>
  <div>
    <Header />
    <v-container>
      <v-row justify="center" align="center" fill-height>
        <v-col cols="12" xl="8">
          <v-alert type="error" v-if="error">{{error}}</v-alert>
          <v-card :loading="loading">
            <v-container>
              <v-card-title>Neue Kategorie</v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <p>Füllen Sie bitte alle Felder aus, um eine neue Kategorie hinzuzufügen.</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-card>
                        <v-card-text>
                          Neue Kategorie
                          <h3 class="headline">Bitte füllen Sie alle Felder aus</h3>
                          <v-text-field
                            class="pt-5"
                            autofocus
                            placeholder="Name"
                            outlined
                            label="Name"
                            v-model="category.name"
                          ></v-text-field>
                          <v-textarea
                            class="pt-5"
                            autofocus
                            placeholder="Beschreibung"
                            outlined
                            label="Beschreibung"
                            v-model="category.description"
                          ></v-textarea>
                        </v-card-text>

                        <v-card-actions class="justify-center">
                          <v-btn large color="primary" @click="create">Speichern</v-btn>
                          <v-btn large color="error" @click="deleteCategory">Löschen</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-row>
                        <v-card>
                          <v-container>
                            <v-img v-if="category.url" :src="category.url">
                              <v-btn @click="category.url = null" class="primary" small>Ersetzten</v-btn>
                            </v-img>

                            <v-image-input
                              v-if="!category.url"
                              v-model="categoryImage"
                              :image-quality="100"
                              imageMinScaling="contain"
                              clearable
                              image-format="png"
                            />
                          </v-container>
                        </v-card>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Header from "@/views/general/header";
import router from "@/plugins/router";

import ProductService from "@/services/ProductService";
import AssetService from "@/services/AssetService";

export default {
  name: "editCategory",
  components: {
    Header: Header
  },
  data: () => ({
    loading: true,
    error: null,
    categoryImage: null,
    category: {
      name: null,
      description: null,
      assetId: null,
      url: null
    }
  }),
  mounted() {
    this.refresh();
  },
  methods: {
    async create() {
      try {
        this.loading = true;
        try {
          if (this.categoryImage) {
            this.category.assetId = (
              await AssetService.upload(this.categoryImage)
            ).data.id;
          }

          let response = await ProductService.updateProductCategory(
            this.$route.params.id,
            this.category.id,
            this.category.name,
            this.category.description,
            this.category.assetId
          );
        } catch (err) {
          alert(err.message);
        }

        this.loading = false;
        router.push({
          name: "categories",
          params: { id: this.$route.params.id }
        });
      } catch (err) {
        this.loading = false;
        this.error = err.message;
      }
    },
    async deleteCategory() {
      try {
        this.loading = true;
        try {
          let response = await ProductService.deleteProductCategory(
            this.$route.params.id,
            this.category.id
          );
        } catch (err) {
          alert(err.message);
        }

        this.loading = false;
        router.push({
          name: "categories",
          params: { id: this.$route.params.id }
        });
      } catch (err) {
        this.loading = false;
        this.error = err.message;
      }
    },
    async refresh() {
      this.loading = true;
      try {
        this.category = (
          await ProductService.getProductCategory(
            this.$route.params.id,
            this.$route.params.catId
          )
        ).data;

        this.loading = false;
      } catch (err) {
        if (err.response.status == 401) {
          router.replace("/auth/login");
        }
      }
    }
  }
};
</script>

